import { formatPrice } from '@mssgme/shared';

export function printPrice(price) {
    return formatPrice(price.amount, price.currency, navigator.language);
}
